import { render } from "./CertificatesView.vue?vue&type=template&id=5c6516d6&scoped=true"
import script from "./CertificatesView.vue?vue&type=script&lang=js"
export * from "./CertificatesView.vue?vue&type=script&lang=js"

import "./CertificatesView.vue?vue&type=style&index=0&id=5c6516d6&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6516d6"]])

export default __exports__